/**
 * @file Defines the {@link GameStates} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/** Class for handling states of buttons depending on game state */
export class GameStates {
    
    /**
     * Handles managing state of autospin buttons (which changes image asset of button being displayed)
     * @memberof GameStates
     * @protected
     * @instance
     * @type {object}
     */
    _autospin
    
    /**
     * Handles storing which buttons are enabled/disabled in each state
     * @memberof GameStates
     * @protected
     * @instance
     * @type {object}
     */
    _states

    /**
     * Handles managing state of spin buttons (which changes image asset of button being displayed)
     * @memberof GameStates
     * @protected
     * @instance
     * @type {object}
     */
    _spin

    /**
     * Initialize game states
     */
    constructor() {

        //Instantiate members
        this._autospin = Object.create(null)
        this._states   = Object.create(null)
        this._spin     = Object.create(null)

    }

    /** Get autospin */ get autospin() { return this._autospin }
    /** Get states */   get states()   { return this._states }
    /** Get spin */     get spin()     { return this._spin }

    /**
     * Adds game state to handle button states
     * @param {string} name_            - Name of state
     * @param {iron-dog-states} states_ - Object representing buttons states
     */
    addState(name_, states_) {

        let state = Object.create(null) //Create empty state object

        //Loop through states
        for (let i = 0; i < states_.length; i++) {
            
            let s      = states_[i][0] //Store current state to be added
            let button = s.btn         //Store button

            let spin        = /^SPI((?=N)|(?=NFR)|(?=NFS))/g                       //Regex for when autospin button should be disabled
            let stop        = /^STO((?=P)|(?=PFR)|(?=PFS))/g                       //Regex for when spin state should be stop
            let apStop      = /^APSTO((?=P)|(?=PFR)|(?=PFS))/g                     //Regex for when autoplay state should be stop
            let afterSpin   = /^AFTERSPI((?=N)|(?=NWIN)|(?=NWINFR)|(?=NWINFS))/g   //Regex for when autoplay button should be disabled
            let apAfterSpin = /^APAFTERSPI((?=N)|(?=NWIN)|(?=NWINFR)|(?=NWINFS))/g //Regex for when autoplay state should be stop
            let sound       = /^NH/g                                               //Regex for when sound button should be enabled
            let nhfs        = /^NHFS/g                                             //Regex for when autoplay button disabled for starting freespins

            //If autospin should be disabled
            if (spin.test(name_) || afterSpin.test(name_) || nhfs.test(name_)) {
                state.autospin = 'disable'
            }

            state.sound = 'enable'  //Enable sound button

            //If spin state should be stop
            if (stop.test(name_)) {

                this._spin[name_] = 'STOP'    //Store STOP state
                state.autospin    = 'disable' //Disable autospin button

            }

            //Spin state is spin
            else {
                this._spin[name_] = 'SPIN' //Store SPIN state
            }

            //Autoplay button state should be stop
            if (apStop.test(name_) || apAfterSpin.test(name_) || name_ == 'APSPIN') {
                this._autospin[name_] = 'STOP' //Store STOP state
            }
            
            //Autoplay button state should be spin
            else if (name_ === 'APNH') {
                this._autospin[name_] = 'SPIN' //Store SPIN state
            }
            
            //Autoplay button state should be start
            else {
                this._autospin[name_] = 'START' //Store START state
            }

            //Switch on button ID
            switch (button.id) {
                
                //Spin button
                case 'spin':
                    s.state ? state.spin = 'enable' : state.spin = 'disable'
                    break

                //Autospin button
                case 'autospin':
                    s.state ? state.autospin = 'enable' : state.autospin = 'disable'
                    break

                //Bet button
                case 'bet':
                    s.state ? state.bet = 'enable' : state.bet = 'disable'
                    break

                //Paytable button
                case 'paytable':

                    if (name_ === 'APNH') {
                        state.menu = 'enable'
                    }
                    
                    //If state is enabled
                    else if (s.state) {

                        state.menu     = 'enable'
                        state.paytable = 'enable'

                    }

                    //State is disabled
                    else {

                        state.menu     = 'disable'
                        state.paytable = 'disable'

                    }
                    break

            }

        }

        this._states[name_] = state //Add state to states object

    }

}